const ENV = process.env.VUE_APP_ENV

export const ACTIVITYCODE = ENV === 'production' ? 'b8883a17221bbd9b' : '6e318ddc6216049f'
export const CHANNELID = ENV === 'production' ? '14769608' : '1476761230'
export const ORDERLIST = ENV === 'production' ? 'https://mobile.vipkid.com.cn/shoporders/list?_tbc=h#status=2' : 'https://stage-mobile.vipkid-qa.com.cn/shoporders/list?_tbc=h#status=2'

export default {
  env: ENV,
  activityCode: ACTIVITYCODE,
  channelId: CHANNELID,
  orderlist: ORDERLIST
}
